// BUILD-042 — Unified employee workspace, My HR (self). "Employment & Pay" destination,
// composed as internal sub-tabs (Position & status / Manager & team / Compensation /
// Employment history), reusing existing, already-working section components unchanged.
import { SubTabs } from './SubTabs';
import { JobSection, SalarySection, ReportToSection } from '../MyHrSections';
import { EmploymentHistoryList } from './EmploymentHistoryList';
import { splitTermHistory, type TermLike } from '../termHistory';

type Tab = 'position' | 'manager' | 'compensation' | 'history';

interface Term extends TermLike {
  title: string | null;
  departmentId: string | null;
  managerEmployeeId: string | null;
  classification: string | null;
  reason?: string | null;
}

export function EmploymentPaySelfSection({
  employeeId, employeeName, termHistory, employmentStatus, hireDate, managerName, managerEmployeeId,
}: {
  employeeId: string;
  employeeName: string;
  termHistory: Term[];
  employmentStatus: string | undefined;
  hireDate: string | undefined;
  managerName: string | null;
  managerEmployeeId: string | null;
}) {
  const { current, upcoming, history } = splitTermHistory(termHistory);

  return (
    <SubTabs<Tab>
      tabs={[
        { key: 'position', label: 'Position & status' },
        { key: 'manager', label: 'Manager & team' },
        { key: 'compensation', label: 'Compensation' },
        { key: 'history', label: 'Employment history' },
      ]}
      initial="position"
    >
      {(active) => {
        if (active === 'position') {
          return (
            <JobSection
              employeeId={employeeId} employeeName={employeeName}
              current={current} employmentStatus={employmentStatus} hireDate={hireDate}
            />
          );
        }
        if (active === 'manager') {
          return (
            <ReportToSection
              employeeId={employeeId} employeeName={employeeName}
              managerName={managerName} managerEmployeeId={managerEmployeeId}
            />
          );
        }
        if (active === 'compensation') {
          return <SalarySection employeeId={employeeId} employeeName={employeeName} />;
        }
        return <EmploymentHistoryList current={current} upcoming={upcoming} history={history} managerName={managerName} />;
      }}
    </SubTabs>
  );
}
